/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {useEffect} from "react";
import {Redirect, Switch, Route, useLocation} from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {Layout} from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./pages/ErrorsPages/ErrorsPage";
import {List as EmyProjects} from "./modules/EmyProjects/pages/list/List";
import {List as EmyServices} from "./modules/EmyServices/pages/list/List";
import {List as EmyProducts} from "./modules/EmyProducts/pages/list/List";
import {ModuleProvider as EmyProjectModuleProvider} from "./modules/EmyProjects/ModuleContext";
import {ModuleProvider as EmyServiceModuleProvider} from "./modules/EmyServices/ModuleContext";
import {ModuleProvider as EmyProductModuleProvider} from "./modules/EmyProducts/ModuleContext";
import {matchPath} from "react-router";
import {getConfig} from "../_metronic/i18n";

const EmyProjectsList = props =>(
  <EmyProjectModuleProvider>
    <EmyProjects {...props} />
  </EmyProjectModuleProvider>
)

const EmyServicesList = props =>(
  <EmyServiceModuleProvider>
    <EmyServices {...props} />
  </EmyServiceModuleProvider>
)

const EmyProductsList = props =>(
  <EmyProductModuleProvider>
    <EmyProducts {...props} />
  </EmyProductModuleProvider>
)

export function Routes() {
    const {isAuthorized, authUser} = useSelector( ({auth}) => ({ isAuthorized: auth.user != null, authUser: auth.user }), shallowEqual );
    const location = useLocation();
    // console.log(getConfig(), authUser)
    /*TODO
    * ACCEPT http://localhost:3000/emy-projects/projects
    * ..
    * Custom layout for VISITORS
    * */
  useEffect(()=>{
    // alert('route changed '+ location.pathname)
    document.body.classList.add("aside-minimize")
  }, [location.pathname])

  const public_pages = [
    { path: "/emy_projects", component: EmyProjectsList},
    { path: "/emy_services", component: EmyServicesList},
    { path: "/emy_products", component: EmyProductsList},
  ]
  const isPublicPath = matchPath(
    location.pathname,
    {
      path: public_pages.map(r=>r.path),
      exact: true,
      // strict: true
    })

  return (
    <Switch>

      {!isAuthorized ?
        isPublicPath ?
          <Layout>
            {
              public_pages.map(route=>(
                <Route key={route.path} path={route.path} component={route.component}/>
              ))
            }
          </Layout> :
          <Route component={AuthPage} />:
        <Redirect from="/auth" to="/"/>
      }

      <Route path="/error" component={ErrorsPage}/>
      <Route path="/logout" component={Logout}/>


      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login"/>
      ) : (
        <Layout>
          <BasePage/>
        </Layout>
      )}
    </Switch>
  );
}
